import React from 'react'
import createReactClass from 'create-react-class'
import PortfolioModalPanel from './modal-panels/portfolio-modal-panel'

export default createReactClass({
  getInitialState () {
    return {
      showModal: false,
    }
  },
  openModal () {
    this.setState({
      showModal: true,
    })
  },
  closeModal () {
    this.setState({
      showModal: false,
    }, () => {
      this.props.onModalClose()
    })
  },
  renderModalPanel () {
    if (this.state.showModal) {
      return (
        <PortfolioModalPanel {...this.props} closeModal={this.closeModal}/>
      )
    }
    return false
  },
  render () {
    return (
      <span>
        <button type='button' onClick={this.openModal} className="cs-primary-button">New</button>
        {this.renderModalPanel()}
      </span>
    )
  },

  componentWillReceiveProps (nextProps) {
    if (nextProps.isCreated) {
      this.closeModal()
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/new-portfolio-panel.js